<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="cotacoes.content"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="cotacoes.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma cotação encontrada"
      loading-text="Carregando cotações..."
      :options="optionsList"
    >
      <template v-slot:item.company="{ item }">
        <px-situacao-solicitacao-frete-icon :situacao="item.situacao"/>
        {{ item.company.pessoa.nome }}
        <px-status-negociacao v-if="item.respostaFrete"
                              :status-negociacao="item.respostaFrete.statusNegociacao"/>
      </template>
      <template v-slot:item.situacaoCotacao="{ item }">
        <px-situacao-cotacao is-view-fornecedor :situacao="item.cotacaoFrete.situacao"/>
      </template>
      <template v-slot:item.createdIn="{ item }">
        {{ item.cotacaoFrete.createdIn | date }}
      </template>
      <template v-slot:item.coleta="{ item }">
        {{ item.cotacaoFrete.municipioColeta.nome }}
        ({{ item.cotacaoFrete.municipioColeta.estado.sigla}})
      </template>
      <template v-slot:item.entrega="{ item }">
        {{ item.cotacaoFrete.municipioEntrega.nome }}
        ({{ item.cotacaoFrete.municipioEntrega.estado.sigla}})
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon link :to="`/cotacoes/${item.id}`">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { SituacaoCotacao, SituacaoSolicitacaoResposta } from 'px-business-components';

export default {
  props: {
    cotacoes: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'id',
          sortable: false,
        },
        {
          text: 'Cliente',
          value: 'company',
        },
        {
          text: 'Data de entrada',
          value: 'createdIn',
        },
        {
          text: 'Situação da cotação',
          value: 'situacaoCotacao',
        },
        {
          text: 'Coleta',
          sortable: false,
          value: 'coleta',
        },
        {
          text: 'Entrega',
          value: 'entrega',
          sortable: false,
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    isFinalizada() {
      return (item) => item.cotacao
        && item.cotacao.situacao === SituacaoCotacao.keys.FINALIZADA.key;
    },
    isRespondida() {
      return (item) => item.situacaoSolicitacaoResposta
        === SituacaoSolicitacaoResposta.keys.RESPONDIDA.key;
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
  },
};
</script>
